module.exports = __WEBPACK_EXTERNAL_MODULE_516__;


//////////////////
// WEBPACK FOOTER
// external "underscore"
// module id = 516
// module chunks = 0